/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import { Component, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
    createOrganization, resetCreateOrganizationState, getNewOrgDefaultSubscription,
} from "./organizationsSlice";

import _ from 'lodash';
import { Row, Col, Button, Form, Table } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';

import BreadCrumb from '../../common/components/BreadCrumb';
import PanelHeader from "../../common/components/layout/PanelHeader";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";

import Panel from "../../common/components/layout/Panel";
import FormContainer from "../../common/components/layout/FormContainer";
import Container from "../../common/components/layout/Container";
import defaultConfig from './organization-default-config.json';
import styled from "styled-components";
import OnboardOrganizationForm from './OnboardOrganizationForm';

export default class CreateOrganizationContainer extends Component {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <CreateOrganization />
        )
    }
}

function CreateOrganization(props) {
    const breadcrumbItems = [{ label: 'Home', href: '/admin/home', isActive: false }, {
        label: 'Organizations',
        href: '/admin/organizations',
        isActive: false
    }, { label: 'Onboard Organization', href: '', isActive: true }];
    const organizationState = useSelector(state => state.organizations);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [formValid, setFormValid] = useState(true);
    const [orgConfig, setOrgConfig] = useState(defaultConfig);
    const [orgSubscription, setOrgSubscription] = useState(organizationState.defaultSubscription);


    useEffect(() => {
        dispatch(getNewOrgDefaultSubscription());
    }, [dispatch]);

    const reset = () => {
        setOrgConfig(defaultConfig);
        setOrgSubscription(organizationState?.defaultSubscription);
        setAlertMessage(undefined);
        setShowAlert(false);
        setShowSuccess(false);
        setSuccessMessage(undefined);

        dispatch(resetCreateOrganizationState());
    }

    const isValid = () => {
        if (_.isEmpty(orgSubscription)) return false;
        return true;
    };

    useEffect(() => {
        // When open dialog, we clear state.
        if (organizationState.reset) {
            reset()
        }
    }, [organizationState.reset]);

    useEffect(() => {
        // When open dialog, we clear state.
        if (organizationState.successMessage) {
            setSuccessMessage(organizationState.successMessage);
            setShowSuccess(true);
        }
    }, [organizationState.successMessage]);

    useEffect(() => {
        // When open dialog, we clear state.
        if (organizationState.alertMessage) {
            setAlertMessage(organizationState.alertMessage);
            setShowAlert(true);
        }
    }, [organizationState.alertMessage]);

    const handleCreateOrganization = async () => {
        if (!isValid()) {
            setFormValid(false);
        } else {
            dispatch(createOrganization(orgSubscription));
        }
    };

    const PreLikeText = styled.div`
        margin-top: 5px;
        display: block;
        white-space: pre-wrap;
        unicode-bidi: embed;
        font-family: monospace;
        color: #212529;
        font-size: 87.5%;
        `;

    return (
        <Container>
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <PanelHeader
                header={'Onboard Organization'}
                subHeader={'Create (onboard) a new client organization'}
            />
            <Panel>
                {organizationState.loading && (
                    <SpinnerOverlay />
                )}
                <Alert
                    variant={"danger"}
                    show={showAlert}
                    onClose={() => setShowAlert(!showAlert)}
                    dismissible
                    transition={false}
                >
                    {alertMessage}
                </Alert>
                <Alert
                    variant={"success"}
                    show={showSuccess}
                    onClose={() => setShowSuccess(!showSuccess)}
                    dismissible
                    transition={false}
                >
                    {successMessage}
                </Alert>
                <FormContainer>
                    <Form noValidate>
                        <Form.Group controlId="createOrganization">
                            <Row>
                                <Col md={9}>
                                    <OnboardOrganizationForm props={{
                                        orgConfigProp: orgConfig,
                                        orgSubscriptionProp: organizationState.defaultSubscription,
                                        setOrgConfigProp: setOrgConfig,
                                        setOrgSubscription: setOrgSubscription,
                                        formValidProp: formValid,

                                    }} />
                                </Col>

                                <Col md={3} style={{ display: 'flex', flexFlow: 'column', height: '150vh' }}>
                                    <div style={{ position: 'sticky', top: 0, padding: '15px' }}>
                                        <h6 style={{ fontWeight: "600" }}>Help</h6>
                                        <PreLikeText>
                                            <Table size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Property</th>
                                                        <th>Description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ padding: '5px' }}>name</td>
                                                        <td style={{ padding: '5px' }}>The organization name</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }}>givenName</td>
                                                        <td style={{ padding: '2px' }}>The organization owner's given name</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }}>surName</td>
                                                        <td style={{ padding: '2px' }}>The organization owner's surname name</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ padding: '2px' }}>email</td>
                                                        <td style={{ padding: '2px' }}>The organization owner's email.  Must be a valid email address</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </PreLikeText>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                    <Button
                                        id='onboard-btn'
                                        className="btn-min-width-120 btn-height-35"
                                        variant="info"
                                        onClick={() => handleCreateOrganization()}
                                    >ONBOARD
                                    </Button>
                                    <Button
                                        id='cancel-btn'
                                        className="btn-min-width-120 btn-height-35"
                                        style={{ marginLeft: "10px" }}
                                        variant="outline-secondary"
                                        onClick={() => {
                                            reset();
                                            navigate('/admin/organizations')
                                        }}
                                    >CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </FormContainer>
            </Panel>
        </Container>
    );
}
